import React, { useState, useEffect } from 'react'
import { Bar } from 'react-chartjs-2'

const ChartComponent = ({ t, data, userType, selectedUser }) => {
  const [chartData, setChartData] = useState(data)
  const [datasetVisibility, setDatasetVisibility] = useState(
    data.datasets.map(() => true)
  )

  useEffect(() => {
    setChartData(data)
    setDatasetVisibility(data.datasets.map(() => true))
  }, [data])

  const toggleDataset = (datasetIndex) => {
    const newVisibility = [...datasetVisibility]
    newVisibility[datasetIndex] = !newVisibility[datasetIndex]
    setDatasetVisibility(newVisibility)
  }

  const getFilteredData = (t) => {
    return {
      ...chartData,
      datasets: chartData.datasets.map((dataset, index) => ({
        ...dataset,
        label: t(`dashboarComp.${dataset.label}`),
        barPercentage: 1,
        hidden: !datasetVisibility[index]
      }))
    }
  }

  return (
    <div>
      {/* Render HTML checkboxes for each dataset */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          paddingTop: '15px'
        }}
      >
        {chartData.datasets.map((dataset, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              checked={datasetVisibility[index]}
              onChange={() => toggleDataset(index)}
              style={{
                marginTop: 0,
                marginRight: '5px',
                accentColor: '#ed6523'
              }}
            />
            <label
              style={{
                marginRight: '5px',
                marginBottom: 0,
                fontWeight: 200,
                fontSize: '13px',
                fontFamily: 'Poppins, sans-serif'
              }}
            >
              {t(`dashboarComp.${dataset.label}`)}
            </label>
            <div
              style={{
                width: '15px',
                height: '15px',
                backgroundColor: dataset.backgroundColor,
                borderRadius: '50%',
                marginRight: '20px'
              }}
            ></div>
          </div>
        ))}
      </div>
      {/* Render the chart */}
      <div className="panel-body" style={{ height: '38vh' }}>
        <Bar
          data={
            userType == 2 && selectedUser.email == undefined
              ? []
              : getFilteredData(t)
          }
          width={200}
          height={50}
          options={{
            legend: {
              display: false
              // labels: {
              //   usePointStyle: true
              // }
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true
                  }
                }
              ]
              // xAxes: [
              //   {
              //     barPercentage: 1
              //   }
              // ]
            },
            maintainAspectRatio: false
          }}
        />
      </div>
    </div>
  )
}

export default ChartComponent
